export default __webpack_public_path__ + "static/media/Ct4.eab64496.png";